module.exports = __webpack_public_path__ + "static/media/12_tn.4900cac0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/12_tn.jpg
// module id = 321
// module chunks = 0